import { Translate } from "ra-core";
import { useState, type ReactNode } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export const FilterCategory = ({
  icon,
  label,
  children,
  collapsible = false,
  defaultCollapsed = false,
}: {
  icon?: ReactNode;
  label: string;
  children?: ReactNode;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  if (!collapsible) {
    return (
      <div className="flex flex-col gap-2">
        <h3 className="flex flex-row items-center gap-2 font-bold text-sm">
          {icon}
          <Translate i18nKey={label} options={{ _: label }} />
        </h3>
        <div className="flex md:flex-col flex-wrap items-start pl-4">
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <button
        type="button"
        onClick={() => setCollapsed((v) => !v)}
        className="flex flex-row items-center gap-2 font-bold text-sm w-full text-left hover:opacity-70 transition-opacity"
      >
        {collapsed
          ? <ChevronRight className="w-3.5 h-3.5 shrink-0 text-muted-foreground" />
          : <ChevronDown className="w-3.5 h-3.5 shrink-0 text-muted-foreground" />
        }
        {icon}
        <Translate i18nKey={label} options={{ _: label }} />
      </button>
      {!collapsed && (
        <div className="flex md:flex-col flex-wrap items-start pl-4">
          {children}
        </div>
      )}
    </div>
  );
};
